export const CLEAR_ROOT_STATE = '@@root/CLEAR_ROOT_STATE';
